module.exports = __webpack_public_path__ + "media/images/site/sempre_buscando-079d9f0bb342d1dc0e63702efea60da8.jpg";